<template>
  <div>
    <SectionBuilder
      v-if="content"
      v-bind="content"
    />
  </div>
</template>

<script setup lang="ts">
import SectionBuilder from '~/components/Organisms/SectionBuilder/SectionBuilder.vue';
import type { MediaTwoColumnPrimaryBlock } from '~/sanity/types';
defineProps<MediaTwoColumnPrimaryBlock>();
</script>

<style scoped></style>
